import { AxiosResponse } from "axios";
import { EEAverageAndMedianRemuneration } from "../../../Model/Dto/EmploymentEquity/AverageAndMedianRemuneration/AverageAndMedianRemuneration";
import { EmploymentEquityDashboardDto } from "../../../Model/Dto/EmploymentEquity/Dashboard";
import { axiosCoreInstance } from "../../AxiosCoreInterceptor";
import * as ApiUrls from "./ApiUrl.Dashboard";
import { IDropDownOptions } from "../../../Common/Components/FormValidationInputs/AppSelectList";
export const DashboardService = {
    GetEmployeeHeadCount: (request: EmploymentEquityDashboardDto.EmployeeHeadcountRequest): Promise<AxiosResponse<EmploymentEquityDashboardDto.EmployeeHeadcountSummary>> =>
        axiosCoreInstance.post(ApiUrls.GetChartHeadCount, request),

    GetMovementHeadCount: (request: EmploymentEquityDashboardDto.MovementHeadcountRequest): Promise<AxiosResponse<EmploymentEquityDashboardDto.EmployeeHeadcountSummary>> =>
        axiosCoreInstance.post(ApiUrls.GetMovementChartData, request),

    GetDashboardConfig: (scorecardId: string): Promise<AxiosResponse<EmploymentEquityDashboardDto.IDashboardConfigViewModel>> =>
        axiosCoreInstance.get(ApiUrls.GetDashboardConfig + scorecardId),

    SaveConfig: (config: EmploymentEquityDashboardDto.IDashboardConfigViewModel): Promise<AxiosResponse<void>> =>
        axiosCoreInstance.post(ApiUrls.SaveDashboardConfig, config),

    GetIncomeDifferentials: (request: EmploymentEquityDashboardDto.IncomeDifferentialsRequest): Promise<AxiosResponse<EmploymentEquityDashboardDto.IncomeDifferentialsSummary>> =>
        axiosCoreInstance.post(ApiUrls.GetChartIncomeDifferentials, request),

    GetIncomeDifferentialPopup: (request: EmploymentEquityDashboardDto.IncomeDifferentialsRequest): Promise<AxiosResponse<EEAverageAndMedianRemuneration.TopAndBottomEarner[]>> =>
        axiosCoreInstance.post(ApiUrls.GetIncomeDifferentialPopup, request),
    
    GetIncomeDifferentialsAnalysis: (request: EmploymentEquityDashboardDto.IncomeDifferentialAnalysisDtoIn): Promise<AxiosResponse<EmploymentEquityDashboardDto.IncomeDifferentialAnalysisDtoOut>> =>
        axiosCoreInstance.post(ApiUrls.GetChartIncomeDifferentialsAnalysis, request),
    
    GetSourceScorecardLookups: ( scorecardId : string ): Promise<AxiosResponse<IDropDownOptions[]>> => 
        axiosCoreInstance.get(ApiUrls.GetSourceScorecardLookups, { params: { scorecardId: scorecardId } }),
    
    GetEEPlanAnnualTrackingHeadcount: (request: EmploymentEquityDashboardDto.EEPlanHeadcountRequest): Promise<AxiosResponse<EmploymentEquityDashboardDto.EEPlan5YearTrackingDtoOut>> =>
        axiosCoreInstance.post(ApiUrls.GetEEPlanAnnualTrackingHeadcount, request),

    GetEEPlan5YearTrackingHeadcount: (request: EmploymentEquityDashboardDto.EEPlanHeadcountRequest): Promise<AxiosResponse<EmploymentEquityDashboardDto.EEPlan5YearTrackingDtoOut>> =>
        axiosCoreInstance.post(ApiUrls.GetEEPlan5YearTrackingHeadcount, request),
}